export const getCartQuantity = checkout =>
  checkout.lineItems.reduce((total, item) => total + item.quantity, 0);
